<template>
  <div class="state_filter">
    <div class="flex flex-between">
      <h5 class="state_filter--label">{{ label }}</h5>

      <div class="state_filter--select_all">
        <button-link
          @click="selectAll"
          class="state_filter--select_all--button"
        >select all
        </button-link>
        <button-link
          @click="deselectAll"
          class="state_filter--select_all--button"
        >deselect all
        </button-link>
      </div>
    </div>

    <div class="state_filter--list">
      <b-checkbox
        v-for="option in options"
        :key="option.id"
        v-model="filterValue"
        :native-value="option.id"
        @input="handleInput"
        size="is-small"
      >
        {{ option.label }}
      </b-checkbox>
    </div>
  </div>
</template>

<script>
import {ENUMS} from "../../services/enums";

export default {
  name: "FilterPipelineState",
  props: {
    label: {
      type: String,
      default: "Lead Location"
    },
    helpText: String,
    storeModule: {
      type: String,
      required: true
    },
    filterName: {
      type: String,
      required: true
    },
    initialState: Number,
  },
  computed: {
    filterValue: {
      get() {
        return this.$store.state[this.storeModule].filters[this.filterName].recordStates;
      },
      set(value) {
        this.commitState(value)
      }
    },
    options() {
      return [
        { id: ENUMS.StatusStateEnum.Contacting.value, label: ENUMS.StatusStateEnum.Contacting.label },
        { id: ENUMS.StatusStateEnum.Active.value, label: ENUMS.StatusStateEnum.Active.label },
        { id: ENUMS.StatusStateEnum.FollowUp.value, label: ENUMS.StatusStateEnum.FollowUp.label },
        { id: ENUMS.StatusStateEnum.Completed.value, label: ENUMS.StatusStateEnum.Completed.label },
        { id: ENUMS.StatusStateEnum.Dead.value, label: ENUMS.StatusStateEnum.Dead.label },
        { id: ENUMS.StatusStateEnum.NonLead.value, label: ENUMS.StatusStateEnum.NonLead.label },
      ];
    },
    text() {
      if (!this.filterValue.length) return null

      let stateLabelArray = [];

      this.filterValue.forEach(stateId => {
        let state = this.options.find(option => option.id === stateId)
        if (state) {
          stateLabelArray.push(state.label);
        }
      });

      return stateLabelArray.join(", ");
    },
  },
  created() {
    if(this.initialState) {
      this.commitState([this.initialState])
    }

    this.handleInput();
  },
  methods: {
    selectAll() {
      this.filterValue = [
        ENUMS.StatusStateEnum.Contacting.value,
        ENUMS.StatusStateEnum.Active.value,
        ENUMS.StatusStateEnum.FollowUp.value,
        ENUMS.StatusStateEnum.Completed.value,
        ENUMS.StatusStateEnum.Dead.value,
        ENUMS.StatusStateEnum.NonLead.value,
      ];
      this.handleInput();
    },
    deselectAll() {
      this.filterValue = [];
      this.handleInput();
    },
    commitState(values) {
      this.$store.commit(this.storeModule + "/setOneFilter", [
        this.filterName,
        "recordStates",
        values
      ]);
    },
    handleInput() {
      this.$emit("change", this.text);
    },
  }
};
</script>

<style lang="scss" scoped>
@import "../../styles/variables/variables";

.state_filter {

  &--label {
    font-size: 0.875rem;
    font-weight: normal;
  }

  &--select_all {
    display: flex;

    &--button {
      margin-left: 10px;
    }
  }

  &--list {
    padding: 8px 4px 0;
  }
}

::v-deep .b-checkbox.checkbox {
  display: flex !important;
  margin-bottom: 4px;
}
</style>
